import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateApiKey } from "../../services/validateApiKey";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { storageKeys } from "../../constants/storageKeys";
import initialSettings from "../../constants/settings.json";
import Cookies from "js-cookie";

const ApiKeyPage = () => {
  const navigate = useNavigate();
  const [apiKey, setApiKey] = useState("");
  const [baseURL, setBaseURL] = useLocalStorage(
    storageKeys.LLM_API_URL,
    JSON.parse(initialSettings.localStorage.LLM_API_URL)
  );
  const [selectedModel, setSelectedModel] = useLocalStorage(
    storageKeys.LLM_MODEL,
    JSON.parse(initialSettings.localStorage.LLM_MODEL)
  );

  /**
   * Handles saving and validating the API key entered by the user.
   */
  const handleSaveApiKey = async () => {
    try {
      
      await validateApiKey(apiKey, baseURL, selectedModel);
      Cookies.set('apiKey', apiKey, { 
        path: '/pubserv/BPMN-Chatbot-Beta',
        sameSite: 'Lax', 
        secure: true 
      }); // Store the API key in cookies
      navigate("/"); 
    } catch (error) {
      // If validation fails, alert the user
      alert("Error validating API key. Please try again.");
    }
  };

  return (
    <div className="bg-gray d-flex justify-content-center align-items-center vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={6}>
            <Card className="shadow p-4">
              <Card.Body>
                <Form className="mt-4">
                  <Form.Group controlId="formBaseURL">
                    <Form.Control
                      type="text"
                      value={baseURL}
                      onChange={(e) => setBaseURL(e.target.value)}
                      placeholder="Enter custom API base URL ..."
                      className="mb-4"
                    />
                  </Form.Group>

                  <Form.Group controlId="formLlmModel">
                    <Form.Control
                      type="text"
                      value={selectedModel}
                      onChange={(e) => setSelectedModel(e.target.value)}
                      placeholder="Enter LLM model (e.g., gpt-3.5-turbo)..."
                      className="mb-4"
                    />
                  </Form.Group>

                  <Form.Group controlId="formApiKey">
                    <Form.Control
                      type="text"
                      value={apiKey}
                      onChange={(e) => setApiKey(e.target.value)}
                      placeholder="Enter your API key..."
                      className="mb-3"
                    />
                  </Form.Group>
                  <div className="text-center">
                    <Button
                      variant="dark"
                      className="px-4"
                      onClick={handleSaveApiKey}
                    >
                      Validate API Key
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center mt-5">
          <Col xs={12} md={8}>
            <p>* Your privacy is of utmost importance to us. </p>
            <p style={{ color: "rgba(0, 0, 0, 0.6)" }}>
              At the end of your session, we may ask for your consent to donate
              your anonymized experiment data for research purposes.
              <br />
              Rest assured, we adhere to strict data protection measures to
              safeguard your information. Your trust means everything to us.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ApiKeyPage;
